firebird.factory('appInsightsService', [
    '$window',
    '$rootScope',
    'logService',
    'helperService',
    function ($window, $rootScope, logService, helperService) {
        var appInsights;
        var metricThresholds;
        var initialized = false;

        var service = {
            initialize: initialize
        };

        $rootScope.$on('metrics-video-room', processMetrics);

        return service;

        function initialize(context) {
            var config = helperService.getAppInsightsConfig();
            if (!config || !config.instrumentationKey) {
                return;
            }

            appInsights = new Microsoft.ApplicationInsights.ApplicationInsights({
                config: {
                    instrumentationKey: config.instrumentationKey
                }
            });

            appInsights.loadAppInsights(false);

            if (context && context.sessionId) {
                appInsights.context.session.id = context.sessionId;
            }

            metricThresholds = config.metricThresholds;

            setPerformanceMetricsListeners();

            initialized = true;
        }

        function setPerformanceMetricsListeners() {
            $window.preloadedApi.remote.ipcRenderer.onCpuMetricsReceive(function (_, data) {
                broadVideoroomRequestEvent(data);
            });

            $window.preloadedApi.remote.ipcRenderer.onProcessMetricsReceive(function (_, data) {
                var transformed = transformMetricsData(data);
                $rootScope.$broadcast('received-cpu-metrics-video-room', transformed);

                // receiver does detection for thresholds.
                if (thresholdExceeded(transformed)) {
                    broadVideoroomRequestEvent(transformed);
                }
            });
        }

        function broadVideoroomRequestEvent(data) {
            $rootScope.$broadcast('request-metrics-video-room', { metrics: data });
        }

        function processMetrics(_, data) {
            if (!data || !data.metrics) {
                return;
            }

            if (typeof data.metrics === 'number') {
                // CPU load only
                sendCpuUsageEvent(data.metrics, data.videoroomData);
            } else {
                // CPU, GPU metrics
                sendProcessMetricsEvent(data.metrics, data.videoroomData, data.gpuName, data.email);
            }
        }

        function sendCpuUsageEvent(cpuValue, videoroomData) {
            if (!initialized) {
                return;
            }

            var cpuType = getCpuType();

            var commonProperties = {
                load: cpuValue,
                cpuType: cpuType
            };

            appInsights.trackEvent({
                name: 'cpu-usage',
                properties: videoroomData ? Object.assign(commonProperties, videoroomData) : commonProperties
            });
        }

        function sendProcessMetricsEvent(metrics, videoroomData, gpuName, email) {
            if (!initialized) {
                return;
            }

            var result = {};

            if (videoroomData) {
                result.videoroomData = Object.assign(videoroomData);
            }

            if (metrics.cpu) {
                result.cpu = {
                    load: metrics.cpu,
                    loadTotal: metrics.cpuLoadTotal,
                    type: metrics.cpuModel ? metrics.cpuModel : getCpuType()
                };
            }

            if (metrics.memory) {
                result.memory = metrics.memory;
                result.memoryTotal = metrics.memoryTotal;
            }

            if (metrics.gpu) {
                result.gpu = {
                    load: metrics.gpu,
                    memory: metrics.gpuMemory,
                    name: gpuName
                };
            }

            if (appInsights.context.user && !appInsights.context.user.accountId) {
                appInsights.context.user.accountId = email;
            }

            appInsights.trackEvent({
                name: 'process-metrics',
                properties: result
            });
        }

        function getCpuType() {
            return helperService.getSystemInfo().cpuModel;
        }

        function transformMetricsData(data) {
            var meetingWindowMetrics = data['[MeetingWindow]'];
            var gpuProcessMetrics = data['[GPU Helper]'];

            return {
                cpu: meetingWindowMetrics && meetingWindowMetrics.cpu && meetingWindowMetrics.cpu.percentCPUUsage,
                cpuLoadTotal: meetingWindowMetrics && meetingWindowMetrics.cpuLoadTotal,
                cpuModel: meetingWindowMetrics && meetingWindowMetrics.cpuModel,
                memory:
                    meetingWindowMetrics && meetingWindowMetrics.memory && meetingWindowMetrics.memory.workingSetSize,
                memoryTotal: meetingWindowMetrics && meetingWindowMetrics.memoryTotal,
                gpu: gpuProcessMetrics && gpuProcessMetrics.cpu && gpuProcessMetrics.cpu.percentCPUUsage,
                gpuMemory: gpuProcessMetrics && gpuProcessMetrics.memory && gpuProcessMetrics.memory.workingSetSize
            };
        }

        function thresholdExceeded(data) {
            if (!data) {
                return false;
            }

            return (
                Number(data.cpu) >= metricThresholds.cpu ||
                Number(data.memory) >= metricThresholds.memory ||
                Number(data.gpu) >= metricThresholds.gpu ||
                Number(data.gpuMemory) >= metricThresholds.gpuMemory
            );
        }
    }
]);
